<!-- Notes AI card -->
<div class="notes-card" [class.notes-card--expanded]="isCardExpanded" [class.notes-card--pending-review]="isPendingReview">
  @if (isBulkBlocked) {
    <div class="notes-card__bulk-overlay" title="Generando resumen IA"></div>
  }

  <!-- Header: always visible, click to collapse/expand -->
  <div class="notes-card__header" [class.notes-card__header--static]="isPendingReady" (click)="toggleCard()">
    <div class="notes-card__header-left">
      <!-- AI sparkle icon -->
      <mat-icon [svgIcon]="isPendingReview ? 'other_icons_warning' : 'other_icons'" class="notes-card__icon"></mat-icon>
      <div class="notes-card__header-texts">
        <span class="notes-card__title">Resumen de la clase (IA)</span>
        @if (isPendingReady) {
          <span class="notes-card__subtitle">Crea automáticamente un resumen a partir de la transcripción del vídeo.</span>
        }
        @if (isPendingReview) {
          <span class="notes-card__subtitle notes-card__subtitle--pending">{{ pendingReviewSubtitle }}</span>
        }
      </div>
    </div>
    @if (isPendingReady) {
      <!-- Inline generate button: transcript is ready but no notes exist yet -->
      <button type="button" class="notes-cta notes-cta--generate" [disabled]="isGeneratingNotes" (click)="$event.stopPropagation(); generateNotes()">
        @if (isGeneratingNotes) {
          <mat-spinner diameter="14"></mat-spinner>
        }
        Generar resumen IA
      </button>
    }
    @if (isPendingReview) {
      <button
        class="notes-cta notes-cta--review"
        [disabled]="isMarkingReviewed || notesView?.notesStatus === 'processing'"
        (click)="$event.stopPropagation(); markAsReviewed()"
      >
        @if (isMarkingReviewed) {
          <mat-spinner diameter="14"></mat-spinner>
        } @else {
          <svg width="15" height="11" viewBox="0 0 15.3125 10.9375" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.75 0.25c0.33 0.33 0.33 0.87 0 1.2l-9.33 9.33c-0.16 0.16-0.37 0.25-0.6 0.25s-0.44-0.09-0.6-0.25l-4-4c-0.33-0.33-0.33-0.87 0-1.2 0.33-0.33 0.87-0.33 1.2 0l3.4 3.4 8.73-8.73c0.33-0.33 0.87-0.33 1.2 0z"
              fill="#16bd5b"
              fill-rule="evenodd"
            />
          </svg>
        }
        Marcar como revisado
      </button>
    }
    @if (!isPendingReady && !isPendingReview && isCardExpanded && !isLoading && notesView) {
      <svg class="notes-card__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m4 12 6-6 6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    }
    @if (!isPendingReady && !isPendingReview && (!isCardExpanded || isLoading)) {
      <svg
        class="notes-card__chevron notes-card__chevron--down"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m4 8 6 6 6-6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    }
  </div>

  <!-- Body: shown when card is expanded and notes exist (or are loading) -->
  @if (isCardExpanded && !isPendingReady) {
    <div class="notes-card__body">
      @if (isLoading) {
        <!-- Loading skeleton -->
        <div class="notes-state notes-state--loading">
          <mat-spinner diameter="24" class="notes-state__spinner"></mat-spinner>
          <div class="notes-state__texts">
            <span class="notes-state__title">Cargando resumen...</span>
          </div>
        </div>
      }

      @if (!isLoading && notesView) {
        <!-- GENERATING state (processing, no prior content) -->
        @if (notesView.notesStatus === 'processing' && !notesView.notesText) {
          <div class="notes-state notes-state--generating">
            <mat-spinner diameter="28" class="notes-state__spinner"></mat-spinner>
            <div class="notes-state__texts">
              <span class="notes-state__title">Generando resumen...</span>
              <span class="notes-state__subtitle">Analizando la transcripción del vídeo. Esto puede tardar unos segundos.</span>
            </div>
          </div>
        }

        <!-- ERROR state (no prior content) -->
        @if (notesView.notesStatus === 'error' && !notesView.notesText) {
          <div class="notes-state notes-state--error">
            <svg class="notes-state__error-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.609 1.5h10.782l5.609 5.61v10.78L17.391 23.5H6.609L1 17.89V7.11L6.609 1.5Z"
                fill="none"
                stroke="#e03131"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path d="m8.219 8.219 7.562 7.562M15.781 8.219l-7.562 7.562" stroke="#e03131" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="notes-state__texts">
              <span class="notes-state__title">Se ha producido un error al generar el resumen</span>
              <span class="notes-state__subtitle">
                {{ notesErrorLabels[notesView.notesErrorCode ?? ''] ?? notesErrorFallback }}
              </span>
            </div>
            <button class="notes-cta" [disabled]="isGeneratingNotes" (click)="$event.stopPropagation(); generateNotes()">
              @if (isGeneratingNotes) {
                <mat-spinner diameter="14"></mat-spinner>
              }
              Reintentar
            </button>
          </div>
        }

        <!-- CONTENT area (ready, or processing with prior content, or error with prior content) -->
        @if (notesView.notesStatus === 'ready' || notesView.notesText) {
          <!-- Content editor -->
          <div class="notes-content" [class.notes-content--disabled]="notesView.notesStatus === 'processing'">
            <quill-editor
              [(ngModel)]="editorContent"
              [modules]="quillModules"
              [readOnly]="notesView.notesStatus === 'processing'"
              (onContentChanged)="onEditorContentChange($event)"
              (onEditorCreated)="onEditorCreated($event)"
              placeholder="Contenido del resumen..."
              theme="snow"
            >
            </quill-editor>

            <!-- Regenerating overlay -->
            @if (notesView.notesStatus === 'processing') {
              <div class="notes-editor__regenerating">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Regenerando resumen…</span>
              </div>
            }
          </div>

          <!-- Label -->
          <span class="notes-editor__label">Texto del resumen</span>

          <!-- Bottom row: publish toggle + action buttons -->
          <div class="notes-card__row">
            <!-- Publish toggle -->
            <app-enfaf-switch-dark
              [control]="publishedControl"
              label="Mostrar resumen"
              [disabled]="notesView.notesStatus === 'processing'"
              (onChange)="togglePublished()"
            ></app-enfaf-switch-dark>

            <div class="notes-card__actions">
              <!-- Regenerate button -->
              <button
                class="notes-cta"
                [disabled]="notesView.notesStatus === 'processing' || isGeneratingNotes"
                (click)="$event.stopPropagation(); generateNotes()"
              >
                @if (isGeneratingNotes) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Regenerar
              </button>

              <!-- Eliminar button -->
              <button
                class="notes-cta notes-cta--danger"
                [disabled]="notesView.notesStatus === 'processing' || isDeleting"
                (click)="$event.stopPropagation(); confirmDeleteNotes()"
              >
                @if (isDeleting) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Eliminar
              </button>
            </div>
          </div>
        }

        <!-- TRANSCRIPT PROCESSING state -->
        @if (notesView.transcriptStatus === 'processing') {
          <div class="notes-state notes-state--generating">
            <mat-spinner diameter="28" class="notes-state__spinner"></mat-spinner>
            <div class="notes-state__texts">
              <span class="notes-state__title">Generando transcripción…</span>
              <span class="notes-state__subtitle">Procesando el audio del vídeo. Esto puede tardar unos segundos.</span>
            </div>
          </div>
        }

        <!-- TRANSCRIPT ERROR state (only when no notes exist yet) -->
        @if (notesView.transcriptStatus === 'error' && notesView.notesStatus === 'pending') {
          <div class="notes-state notes-state--error">
            <svg class="notes-state__error-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.609 1.5h10.782l5.609 5.61v10.78L17.391 23.5H6.609L1 17.89V7.11L6.609 1.5Z"
                fill="none"
                stroke="#e03131"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path d="m8.219 8.219 7.562 7.562M15.781 8.219l-7.562 7.562" stroke="#e03131" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="notes-state__texts">
              <span class="notes-state__title">Se ha producido un error al generar el resumen</span>
              <span class="notes-state__subtitle">
                {{ transcriptErrorLabels[notesView.transcriptError ?? ''] ?? transcriptErrorFallback }}
              </span>
            </div>
            <button class="notes-cta" [disabled]="isGeneratingTranscript" (click)="generateTranscript()">
              @if (isGeneratingTranscript) {
                <mat-spinner diameter="14"></mat-spinner>
              }
              Reintentar transcripción
            </button>
          </div>
        }

        <!-- No transcript yet (hidden during auto-flow) -->
        @if (notesView.transcriptStatus === 'pending' && notesView.notesStatus === 'pending' && !isAutoFlow) {
          <div class="notes-state notes-state--hint">
            <span class="notes-state__subtitle">Sin transcripción de vídeo disponible. Genera la transcripción primero.</span>
            <button class="notes-cta" [disabled]="isGeneratingTranscript" (click)="generateTranscript()">
              @if (isGeneratingTranscript) {
                <mat-spinner diameter="14"></mat-spinner>
              }
              Generar transcripción
            </button>
          </div>
        }
      }
    </div>
  }
</div>
